import { toast } from 'components';
import i18n from 'i18n';
import { selectFiscalYear } from 'actions/user-companies/select';
import fetch from '../../utils/fetch';

export function error(error) {
  return {
    type: 'FISCAL_YEAR_LIST_ERROR',
    error,
  };
}

export function loading(loading) {
  return {
    type: 'FISCAL_YEAR_LIST_LOADING',
    loading,
  };
}

export function success(data) {
  return {
    type: 'FISCAL_YEAR_LIST_SUCCESS',
    data,
  };
}

export function list(page = '/fiscal_years') {
  return (dispatch, getState) => {
    const { userCompanies: { select: { selectedFiscalYear } } } = getState();
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response => response.json())
      .then((data) => {
        dispatch(loading(false));
        dispatch(success(data));

        if (data && data['hydra:member']) {
          data['hydra:member'].forEach((fiscalYear) => {
            if (selectedFiscalYear && fiscalYear['@id'] === selectedFiscalYear['@id']) {
              dispatch(selectFiscalYear(fiscalYear));
            }
          });
        }
      })
      .catch((e) => {
        toast.error(i18n.t('toastError'));
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

export function reset() {
  return {
    type: 'FISCAL_YEAR_LIST_RESET',
  };
}
